import ExclamatoryMarkErrorIcon from "../../../../../../assets/svg/exclamatory-mark-error-icon";
import AlertIcon from "../../../../../../assets/svg/alert-icon";
import LeftArrowIcon from "../../../../../../assets/svg/left-arrow-icon";
import { CreateUserHeader } from "./CreateUserHeader";
import { CreateUserError, UserCreatedPreviewData } from "../utils/types";
import { ROLE_CONFIG } from "../../../RolesLayout/utils/constants";
import Table from "../../../../../../components/Table/Table";
import { createUserTableColumns } from "./UserCreatedPreview/utils/constants";
import { ColumnDef } from "@tanstack/react-table";

interface UserCreationErrorViewProps {
  handleCloseDrawer: () => void;
  createUserError: CreateUserError;
  handleBack: () => void;
}

export const UserCreationErrorView = ({
  handleCloseDrawer,
  createUserError,
  handleBack,
}: UserCreationErrorViewProps) => {
  const errorDetail = createUserError?.error_logs || "Failed to create user";
  return (
    <div className="p-[18px]">
      <CreateUserHeader handleCloseDrawer={handleCloseDrawer} />
      <button
        onClick={handleBack}
        className="flex items-center gap-1 py-[18px]"
      >
        <LeftArrowIcon className="w-3.5 h-3.5 text-verba-indigo dark:text-verba-indigo-dk" />
        <span className="text-xs font-medium text-heading-text dark:text-heading-text-dk">
          Go Back
        </span>
      </button>

      <div className="w-full h-px bg-border-gray dark:bg-border-gray-dk" />
      <div className="flex flex-col gap-1 border border-tag-red-stroke dark:border-tag-red-stroke-dk rounded-lg py-2.5 px-3">
        <div className="flex items-center gap-2">
          <AlertIcon className="w-6 h-6 shrink-0 text-verba-red-alert dark:text-verba-red-alert-dk" />
          <div className="flex flex-col gap-0.5">
            <div className="flex items-center gap-1">
              <span className="text-md text-heading-text dark:text-heading-text-dk font-semibold">
                Oops, User Upload Failed
              </span>
              <span className="text-xxs leading-none text-verba-red-alert dark:text-verba-red-alert-dk font-semibold px-[4.2px] py-[1.5px] border border-tag-red-stroke dark:border-tag-red-stroke-dk rounded-sm bg-tag-red-bg dark:bg-tag-red-bg-dk">
                1
              </span>
            </div>
            <span className="text-xs text-data dark:text-data-dk leading-4">
              We encountered errors while processing your user upload. The
              affected user was not added. Please check the error log for
              details and check details before retrying.
            </span>
          </div>
        </div>
      </div>

      <div className="mt-[18px] mb-9">
        <Table
          COLUMNS={
            createUserTableColumns() as ColumnDef<UserCreatedPreviewData>[]
          }
          COLUMNS_DATA={
            [
              {
                user: {
                  name: createUserError?.data?.name,
                  email: createUserError?.data?.email,
                  phone: `${createUserError?.data?.country_code} ${createUserError?.data?.phone_number}`,
                },
                role: {
                  label:
                    ROLE_CONFIG[
                      createUserError?.data?.role as keyof typeof ROLE_CONFIG
                    ]?.label,
                  value: createUserError?.data?.role,
                },
                created_by: createUserError?.data?.created_by,
                created_at: createUserError?.data?.created_at,
                clients: createUserError?.data?.clients,
              },
            ] as unknown as UserCreatedPreviewData[]
          }
          ariaLabel="Users table"
          minHeight="86px"
          cellClassName="!p-0 !h-[52px]"
        />
      </div>

      <div className="text-md text-verba-indigo dark:text-verba-indigo-dk font-medium mb-2">
        Error Logs
      </div>

      <div className="flex flex-col">
        <div className="flex items-center gap-0.5">
          <ExclamatoryMarkErrorIcon className="w-4 h-4 text-verba-red-alert dark:text-verba-red-alert-dk" />
          <span className="text-sm text-verba-red-alert dark:text-verba-red-alert-dk">
            {errorDetail}
          </span>
        </div>
      </div>
    </div>
  );
};
